import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";

const environment = getEnvironment();

export interface WaitlistEntry {
    bookingKey: string; // Encrypted booking ID
    bookingNote: string | null; // Client preferences comment
    serviceKey: string; // Encrypted service ID
    serviceName: string; // Name of the service
    serviceDuration: number; // Duration of the service for DateTimePicker scheduling flow
}

export interface WaitlistUser {
    userKey: string;
    userName: string;
    userPhoto: string | null;
    hasPriority: boolean;
    waitlistEntries: WaitlistEntry[];
}

export default class Waitlist {
    public static readonly usersList = async (
        uuid: string,
        brand: string
    ): Promise<WaitlistUser[]> => {
        try {
            const response = await axios.get(
                `${environment.api_url}/${brand}/user/waitlist`,
                {
                    headers: {
                        "User-Token": uuid,
                    },
                }
            );

            if (response.status === 200) {
                return response.data as WaitlistUser[];
            }

            console.error("Failed to fetch waitlist: ", response.statusText);
            return [];
        } catch (error) {
            console.error("Error fetching waitlist: ", error);
            return [];
        }
    };
}
